var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qx-card-form',{attrs:{"title":"归属"}},[_c('qx-custom-form',{ref:"baseForm",attrs:{"noSubBtn":true,"formData":_vm.baseForm,"labelWidth":"180px"}}),_c('button',{staticClass:"test-btn",on:{"click":_vm.getDataTest}},[_vm._v("测试提交参数")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }